import { bindRequestLogic } from './utils'
import CardMarketPlaceTypes from '../actionTypes/cardMarketPlace'
import { cardMarketplaceAPI } from '../api'

const getCardMarketplaces = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.getCardMarketplaces,
  type: CardMarketPlaceTypes.GET_CARD_MARKET_PLACES_REQUEST,
  successType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACES_SUCCESS,
  failType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACES_FAILED,
  isQueryParam: true
})

const addCardMarketPlace = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.addCardMarketplace,
  type: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_REQUEST,
  successType: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_SUCCESS,
  failType: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_FAILED
})

const updateCardMarketPlace = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.updateCardMarketplace,
  type: CardMarketPlaceTypes.UPDATE_CARD_MARKET_PLACE_REQUEST,
  successType: CardMarketPlaceTypes.UPDATE_CARD_MARKET_PLACE_SUCCESS,
  failType: CardMarketPlaceTypes.UPDATE_CARD_MARKET_PLACE_FAILED
})

const getCardMarketPlace = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.getCardMarketplace,
  type: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_DETAIL_REQUEST,
  successType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_DETAIL_SUCCESS,
  failType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_DETAIL_FAILED,
  modelName: 'scwCardMarketplace'
})

const deleteCardMarketPlace = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.deleteCardMarketplace,
  type: CardMarketPlaceTypes.DELETE_CARD_MARKET_PLACE_REQUEST,
  successType: CardMarketPlaceTypes.DELETE_CARD_MARKET_PLACE_SUCCESS,
  failType: CardMarketPlaceTypes.DELETE_CARD_MARKET_PLACE_FAILED
})

const addCardMarketPlaceContent = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.addCardMarketplaceContent,
  type: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_CONTENT_REQUEST,
  successType: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_CONTENT_SUCCESS,
  failType: CardMarketPlaceTypes.ADD_CARD_MARKET_PLACE_CONTENT_FAILED
})

const getCardMarketPlaceContents = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.getShowcaseContents,
  type: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_CONTENTS_REQUEST,
  successType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_CONTENTS_SUCCESS,
  failType: CardMarketPlaceTypes.GET_CARD_MARKET_PLACE_CONTENTS_FAILED
})

const changeCardMarketplaceStatus = bindRequestLogic({
  clientFunc: cardMarketplaceAPI.changeCardMarketplaceStatus,
  type: CardMarketPlaceTypes.CHANGE_CARD_MARKET_PLACE_STATUS_REQUEST,
  successType: CardMarketPlaceTypes.CHANGE_CARD_MARKET_PLACE_STATUS_SUCCESS,
  failType: CardMarketPlaceTypes.CHANGE_CARD_MARKET_PLACE_STATUS_FAILED
})

export default [
  getCardMarketplaces,
  addCardMarketPlace,
  deleteCardMarketPlace,
  updateCardMarketPlace,
  getCardMarketPlace,
  addCardMarketPlaceContent,
  getCardMarketPlaceContents,
  changeCardMarketplaceStatus
]
